import api from '@/utils/api';

/**
 * delete user
 *
 * @param {string} userRoleId - The user role id
 * @returns {Promise} The promise object of the api call
 */
const deleteUserRoleApi = (userRoleId) => api.delete(`user-role/${userRoleId}`);

export default deleteUserRoleApi;
